/**
 * Created by Zyy.
 * User: zouyingyang@qq.com
 * Date: 2018/9/15
 * Time: 14:12
 * Desc: 返回码统一处理
 */
import { Message } from "element-ui";
import router from "@/router";
import {
  useCheckResponseType,
  checkResponseType,
  buildErrorHtmlMessage,
} from "@oppein/op-utils";
const { checkAxiosResponseType } = useCheckResponseType(Message, {
  duration: 10000,
  showSupportDeskGuide: true,
});

/**
 * 安全的跳转方法，支持 iframe 环境下的父窗口跳转
 * @param {string} url - 跳转目标地址
 */
const safeRedirect = (url) => {
  try {
    // 如果在 iframe 中，尝试让父窗口跳转
    if (window.parent && window.parent !== window) {
      window.parent.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch (e) {
    // 跨域情况下使用 postMessage 通知父窗口
    window.parent.postMessage(
      {
        type: "LOGIN_EXPIRED",
        message: "登录已过期，请重新登录",
        redirectUrl: url,
      },
      "*",
    );
  }
};

export default [
  (response) => {
    const handleLocation = () => {
      //  如果url里带有已失效token就去掉
      return (
        response.data.data +
        encodeURIComponent(
          location.href.replace(
            /(Oauth2-AccessToken|accessToken)=[0-9,a-z]+&?/g,
            "",
          ),
        ) +
        `&AppCode=${process.env.DEPLOY_ENV === "mtds2-child" ? "MTDS" : "CAXA"}&SubAppCode=${process.env.DEPLOY_ENV === "mtds2-child" ? "MTDSPC001" : "CAXAPC001"}`
      );
    };
    if (
      response &&
      ["110001", "110013", "110016"].join(",").indexOf(response.data.code) !==
        -1
    ) {
      safeRedirect(handleLocation());
      return response;
    } else if (response.data.code && +response.data.code === 261024) {
      response.data.message = response.data.message
        .split("<br/>")
        .join("<br/> &nbsp&nbsp&nbsp&nbsp");
      window.sessionStorage.setItem(
        "releaseVersionMessage",
        JSON.stringify(response.data.message),
      );
      router.push({ name: "release-version" });
      return response;
    } else if (
      (+response.data.code >= 378000 && +response.data.code <= 379999) ||
      +response.data.code === 265070 ||
      +response.data.code === 261029
    ) {
      // 265070 用于金属门窗跳转iframe 261029=>订单关闭失败
      response.data.status = true;
      return response;
    } else if (
      response.data.code &&
      +response.data.code !== 100000 &&
      +response.data.code !== 200 &&
      +response.data.code !== 280122 &&
      +response.data.code !== 101011 &&
      +response.data.code !== 261027 &&
      +response.data.code !== 230001
    ) {
      // 处理新增公共提示逻辑
      const {
        data: { code },
        config: { url },
      } = response;

      if (checkResponseType(url, code)) {
        checkAxiosResponseType(response);
        return response;
      }

      const options = {};
      options.message =
        response.data.message ||
        response.message ||
        response.data.msg ||
        response.data.exception ||
        response.data.errMsg ||
        "系统错误请联系管理员";
      options.message = options.message.split(";").join("<br/>");
      Message({
        message: buildErrorHtmlMessage(options.message),
        type: "error",
        duration: 10000,
        dangerouslyUseHTMLString: true,
        showClose: true,
      });
      return response;
    }
    return response;
  },
  (error) => {
    const response = error.response;
    if (
      response &&
      ["110001", "110013", "110016", "110021"]
        .join(",")
        .indexOf(response.data.code) !== -1
    ) {
      safeRedirect(response.data.data + location.href);
    } else {
      const options = {};
      options.message =
        response.data.message ||
        response.message ||
        response.data.msg ||
        response.data.exception ||
        response.data.errMsg ||
        "系统错误请联系管理员";
      options.message = options.message.split(";").join("<br/>");
      Message({
        message: buildErrorHtmlMessage(options.message),
        type: "error",
        duration: 10000,
        dangerouslyUseHTMLString: true,
        showClose: true,
      });
    }
    return Promise.reject(error);
  },
];



// WEBPACK FOOTER //
// ./src/api/response-handle-newsso.js